import React from "react"
import Image from "gatsby-image"
import { Link } from "gatsby"
import { FaGithubSquare, FaShareSquare } from "react-icons/fa"

const Project = ({ description, title, slug, links, stack_icons, image }) => {
  const github = links && links.find(l => l.label === "GitHub")
  const live = links && links.find(l => l.label === "Live")
  const detail = slug ? `/projects/${slug}` : null

  return (
    <article className="project">
      {image && image.childImageSharp && (
        detail ? (
          <Link to={detail} className="project-imgwrap" aria-label={title}>
            <Image fluid={image.childImageSharp.fluid} className="project-img" />
          </Link>
        ) : (
          <div className="project-imgwrap">
            <Image fluid={image.childImageSharp.fluid} className="project-img" />
          </div>
        )
      )}
      <div className="project-info">
        <h3 className="project-title">
          {detail ? <Link to={detail}>{title}</Link> : title}
        </h3>
        <p className="project-desc">{description}</p>

        {stack_icons && stack_icons.length > 0 && (
          <div className="project-stack">
            {stack_icons.slice(0, 5).map((item, idx) => (
              <span key={idx} className="project-chip">
                {item.name}
              </span>
            ))}
          </div>
        )}

        <div className="project-foot">
          {detail && (
            <Link to={detail} className="project-case-link">
              view case study <span aria-hidden="true">→</span>
            </Link>
          )}
          {(github || live) && (
            <span className="project-ext">
              {github && (
                <a href={github.url} aria-label="GitHub" target="_blank" rel="noopener noreferrer">
                  <FaGithubSquare className="project-icon" />
                </a>
              )}
              {live && (
                <a href={live.url} aria-label="Live site" target="_blank" rel="noopener noreferrer">
                  <FaShareSquare className="project-icon" />
                </a>
              )}
            </span>
          )}
        </div>
      </div>
    </article>
  )
}

export default Project
